import { container_classname } from "@components/new-ui/constants";
import Image from "next/image";

interface ProblemCard {
    imageUrl: string;
    title: string;
    description: string;
}

export interface ProblemSection {
    maintitle: string;
    problemSectionCard: ProblemCard[];
}

export interface ProblemSectionProps {
    problemSection?: ProblemSection;
    bgColor?: string;
    customStyle?: boolean;
}

const ProblemSectionData: ProblemSection = {
    maintitle: "Your sales pipeline deserves better than ghosted leads",
    problemSectionCard: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/personalisation.svg",
            title: "Inability to personalize at scale",
            description: "Handling multiple prospect interactions manually can lead to poor prioritization and missed revenue targets.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/pipleline.svg",
            title: "The challenge of following up with your leads",
            description: "Manually (or worse, mentally) tracking your leads, following up with them, and updating contacts hurts outreach efficiency",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/campaign.svg",
            title: "Building personalized campaigns is a task",
            description: "Manually building personalized outreach campaigns is time-intensive and leads to longer decision making cycles.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
            title: "Difficulty in connecting with other tools",
            description: "No communication between your tech stack means chaotic sales processes, and huge revenue leakages.",
        },
    ],
};

const ProblemSection: React.FC<ProblemSectionProps> = ({ problemSection = ProblemSectionData, bgColor, customStyle }) => {
    return (
        <section className={`${customStyle ? "mb-0 py-20" : "mb-20 py-20 mt-20"}`} style={bgColor ? { background: bgColor } : { backgroundColor: "#E6EEFF" }}>
            <h5 className={`${container_classname} md:text-6xl text-4xl mb-12 ${customStyle ? "text-white" : ""}`} style={{ fontFamily: "Degular Display" }}>
                {problemSection.maintitle}
            </h5>
            <div className={`${container_classname} flex md:flex-row flex-col gap-5`}>
                {problemSection.problemSectionCard.map((problemsData, index) => (
                    <div key={index} className="flex flex-col gap-4 bg-white p-6 shadow-md">
                        <Image src={problemsData.imageUrl} alt={problemsData.title} width={48} height={48} className="h-12" />
                        <p className="font-semibold text-2xl">{problemsData.title}</p>
                        <p className="self-end">{problemsData.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ProblemSection;
